import API from './API.js';
export default class Library extends API {
    constructor() {
        super('Library/library');
    }

}
